import { Printer, X } from "lucide-react";
import "./CreditReport.css";
import Header from "../../../Components/TransunionHybrid/Header";
import ConsumerCIR from "../../../Components/TransunionHybrid/ConsumerCIR";
import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import AccountAndEnquirySummary from "../../../Components/TransunionHybrid/Summary";
import PersonalDetails from "../../../Components/TransunionHybrid/PersonalInfoSection";
import ConsumerAccountDetails from "../../../Components/TransunionHybrid/AccountDetails";
import ConsumerEnquiryDetails from "../../../Components/TransunionHybrid/EnquirySection";
import GlossarySection from "../../../Components/TransunionHybrid/Glossary";

// Import sections
// import Header from "./sections/Header";
// import PersonalInfo from "./sections/PersonalInfo";
// import Score from "./sections/Score";
// import Accounts from "./sections/Accounts";
// import Enquiries from "./sections/Enquiries";
// import AddressHistory from "./sections/AddressHistory";
// import Footer from "./sections/Footer";

// https://commons.wikimedia.org/wiki/File:TU-CIBIL-logo.jpg

const TransunionHybridModal = ({ report, onClose }) => {
  const reportRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "TransUnion Credit Report",
    
  });
  return (
    <div className="parent bg-black/30 backdrop-blur-md no-scrollbar">
      <div className="flex items-center gap-3 my-2">
        {/* Secondary / Close Button */}
        <button
          type="button"
          onClick={onClose}
          className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-slate-700 bg-white border border-slate-200 rounded-xl hover:bg-slate-50 hover:text-slate-900 active:scale-95 transition-all shadow-sm focus:outline-none focus:ring-2 focus:ring-slate-400/20"
        >
          <X className="w-4 h-4 text-slate-500" />
          Close
        </button>

        {/* Primary / Print Button */}
        <button
          onClick={handlePrint}
          type="button"
          className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-xl hover:bg-indigo-700 active:scale-95 transition-all shadow-sm shadow-indigo-200 focus:outline-none focus:ring-2 focus:ring-indigo-500/30"
        >
          <Printer className="w-4 h-4" />
          Print
        </button>
      </div>
      <div ref={reportRef} className="report-wrapper  no-scrollbar">
        <div className="report-page">
          <Header reportData={report} />
          <ConsumerCIR reportData={report} />

          <AccountAndEnquirySummary accountData={report?.accounts} enquiryData={report} summary={report?.reportSummary} />

          <PersonalDetails report={report} />


          <ConsumerAccountDetails accounts={report?.accounts} />

          <ConsumerEnquiryDetails enquiries={report?.enquiries} />

          <GlossarySection consumerName={report?.personal?.name} />
        </div>
      </div>
    </div>
  );
};

export default TransunionHybridModal;
